module.exports = __webpack_public_path__ + "static/media/cisco_logo.eb883385.svg";